import PageLoader from "components/PageLoader";
import { useAuth } from "context/providers/auth";
import { useEffect } from "react";
import { useSearchParams } from "react-router-dom";

const ConfirmEmail = () => {
  const [searchParams] = useSearchParams();
  const confirmation_token = searchParams.get("confirmation_token");
  const { handleConfirmEmail } = useAuth();

  useEffect(
    () => {
      handleConfirmEmail(confirmation_token);
    },
    // eslint-disable-next-line
    [confirmation_token]
  );

  return <PageLoader />;
};

export default ConfirmEmail;
